import React from 'react';
import { TConsumerItem, TSelectorRegularData } from '../../../types/data';
import { TRowOption, TSelectorRegularOption } from '../../../types/options';
import { Switcher } from '../../Checkbox/Switcher';
import { VisualView } from '../../Image/VisualView';
import { Tag } from '../Tag/Tag';

type TSelectorRegularRight = {
    uid: string;
    handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
} & Pick<TSelectorRegularData, 'value'> &
    Pick<TRowOption, 'metaVariant' | 'metaHierarchy'> &
    Pick<TConsumerItem, 'metaText'> &
    Pick<TSelectorRegularOption, 'isDisabled' | 'variant'>;

export const SelectorRegularRight = ({ uid, variant, value, metaText, metaVariant, metaHierarchy, isDisabled, handleChange }: TSelectorRegularRight) => {
    if (variant) {
        return (
            <>
                {variant === 'SWITCHER' && (
                    <div onClick={(e) => e.stopPropagation()}>
                        <Switcher isWidget={false} uid={uid} isDisabled={isDisabled} value={value} handleChange={handleChange} />
                    </div>
                )}
                {variant === 'CHECK' && value === true && <VisualView iconName={'ic_check'} size={'small'} isDisabled={isDisabled} />}
            </>
        );
    }
    if (metaText) {
        return <Tag metaText={metaText} metaVariant={metaVariant} metaHierarchy={metaHierarchy ?? 'secondary'} isDisabled={isDisabled} />;
    }
    return false;
};
